import RestService from '../services/rest';
import StorageService from '../services/storage';

function getSearchOptions(searchOptions) {
  let url = `limit=${searchOptions.limit}&skip=${searchOptions.skip}`;
  if (searchOptions.text) url += `&text=${searchOptions.text}`;
  if (searchOptions.type) url += `&type=${searchOptions.type}`;
  if (searchOptions.mainCategories) url += `&mainCategories=${searchOptions.mainCategories.join(';')}`;
  if (searchOptions.subCategories) url += `&subCategories=${searchOptions.subCategories.join(';')}`;
  if (searchOptions.brands) url += `&brands=${searchOptions.brands.join(';')}`;
  if (searchOptions.pdmsModifiers) url += `&pdmsModifiers=${searchOptions.pdmsModifiers.join(';')}`;
  if (searchOptions.pdmsParticulars) url += `&pdmsParticulars=${searchOptions.pdmsParticulars.join(';')}`;
  if (searchOptions.order) url += `&sort_selected=${searchOptions.order}`;
  if (searchOptions.minPrice) url += `&minPrice=${searchOptions.minPrice}`;
  if (searchOptions.maxPrice) url += `&maxPrice=${searchOptions.maxPrice}`;
  if (searchOptions.previousSearchId) url += `&previousSearchId=${searchOptions.previousSearchId}`;
  return url;
}

async function getFeatured() {
  return RestService.getRest('products/spotlight');
}

async function getClientFeatured(clientId) {
  return RestService.getAuthenticated(`products/client/spotlight?client=${clientId}`);
}

async function getClientRecommended(clientId) {
  return RestService.getAuthenticated(`products/client/recommendeds?client=${clientId}`);
}

async function getClientSimilar(clientId, productId) {
  return RestService.getAuthenticated(`products/client/similar?client=${clientId}&product=${productId}`);
}

async function getClientCrossSelling(clientId, productId) {
  return RestService.getAuthenticated(`products/client/cross-selling?client=${clientId}&product=${productId}`);
}

async function getClientPromotions(clientId) {
  return RestService.getAuthenticated(`products/client/promotions?client=${clientId}`);
}

async function getSearch(searchOptions) {
  let url = 'products/search/elastic?';
  url += getSearchOptions(searchOptions);
  return RestService.getRest(url);
}

async function getClientSearch(clientId, searchOptions) {
  let url = `products/client/search/elastic?client=${clientId}&`;
  url += getSearchOptions(searchOptions);
  return RestService.getAuthenticated(url);
}

async function getSoneparSearch(clientId, searchOptions) {
  let url = 'products/search/sonepar?';
  url += getSearchOptions(searchOptions);
  const result = await RestService.getRest(url);
  if (result && result.searchId) StorageService.set('search_id_sonepar', result.searchId);
  return result;
}

async function getClientSoneparSearch(clientId, searchOptions) {
  let url = `products/client/search/sonepar?client=${clientId}&`;
  url += getSearchOptions(searchOptions);
  const result = await RestService.getAuthenticated(url);
  if (result && result.searchId) StorageService.set('search_id_sonepar', result.searchId);
  return result;
}

async function getFilters(searchOptions) {
  let url = 'products/filters?';
  url += getSearchOptions(searchOptions);
  return RestService.getRest(url);
}

async function getClientFilters(clientId, searchOptions) {
  let url = `products/client/filters?client=${clientId}&`;
  url += getSearchOptions(searchOptions);
  return RestService.getAuthenticated(url);
}

async function getDetails(productId) {
  const searchIdSonepar = StorageService.get('search_id_sonepar');
  return RestService.getRest(`products/details?product=${productId}&searchIdSonepar=${searchIdSonepar}`);
}

async function getClientDetails(clientId, productId, code, isPunchOut, forceToGetProductLeadTime) {
  const clientCodeUrl = code && code !== '0' ? `&code=${code}` : '';
  const itsPunchOutUrl = isPunchOut ? `&isPunchOut=${isPunchOut}` : '';
  const searchIdSonepar = StorageService.get('search_id_sonepar');
  const productLeadTime = forceToGetProductLeadTime ? `&forceProductLeadTime=${forceToGetProductLeadTime}` : '';

  return RestService.getAuthenticated(
    'products/client/details'
    + `?client=${clientId}`
    + `&product=${productId}`
    + `${clientCodeUrl}`
    + `${itsPunchOutUrl}`
    + `&searchIdSonepar=${searchIdSonepar}`
    + `${productLeadTime}`,
  );
}

async function getPricing(clientId, userId, productIds) {
  return RestService.getAuthenticated(
    `products/pricing?client=${clientId}&user=${userId}&products=${productIds.join(';')}`,
  );
}

async function getSuggests(term, client) {
  const url = `products/client/suggests/?term=${term}&client=${client}`;
  return RestService.getAuthenticated(url);
}

async function getSuggestsNoClient(term) {
  return RestService.getAuthenticated(`products/suggests/?term=${term}`);
}

export default {
  getFeatured,
  getClientFeatured,
  getClientRecommended,
  getClientSimilar,
  getClientCrossSelling,
  getClientPromotions,
  getSearch,
  getClientSearch,
  getFilters,
  getClientFilters,
  getDetails,
  getClientDetails,
  getPricing,
  getSoneparSearch,
  getClientSoneparSearch,
  getSuggests,
  getSuggestsNoClient,
};
